import analytics, { events } from '../../../shared/analytics';
import type { UiElement } from '../../../shared/ui-element/ui-element';

import jump from '../../utils/jump';

import BasePage from '../../components/base-page/base-page';

import './podcast.scss';

class PodcastPage extends BasePage {
  ui = {
    episodesSection: '.js-podcast-episodes',
    listenNowLink: '.js-jump-to-episodes',
  };

  uiCollections = {
    podcastServiceLinks: '.js-podcast-service-link',
  };

  events = {
    'click @ui.listenNowLink': 'scrollToEpisodesSection',
    'click @uiCollections.podcastServiceLinks': 'handlePodcastServiceClick',
  };

  scrollToEpisodesSection = (event) => {
    event.preventDefault();
    jump(this.ui.episodesSection, {
      offset: -100, // sticky navigation height margin
    });
  };

  handlePodcastServiceClick = (event) => {
    const { currentTarget } = event;
    const eventLabel = currentTarget && currentTarget.dataset && currentTarget.dataset.podcastService;
    analytics.trackEvent({ ...events.PODCAST_SERVICE_CLICK, eventLabel });
  };
}

export default PodcastPage;

(PodcastPage as UiElement).initOnDomLoaded();
